import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import BigPickListTemplateContent from 'Views/Page/Content/Templates/BigPickListTemplate/Content';
import useMobileLayout from 'Hooks/useMobileLayout';

const styles = (theme) => ({
  root: {},
  subtitle: {
    marginBottom: theme.spacing(4),
  },
  fields: {
    padding: theme.spacing(0),
  },


  content: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
  },
  contentDesktop: {
    maxWidth: '600px',
  },
  badgeImage: {
    marginBottom: theme.spacing(4),
    width: '140px',
    height: '140px',
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const isMobile = useMobileLayout();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classNames(classes.content, {
        [classes.contentDesktop]: !isMobile,
      })}
      >
        {
          resource.attr('badgeImage')
            ? <img className={classes.badgeImage} src={resource.attr('badgeImage')} alt={resource.attr('badgeImageAlt')} />
            : undefined
        }
        <BigPickListTemplateContent />
      </div>

      <WhatIfStepNavigator
        isLoading={saving}
        onNext={() => {
          onSubmit();
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
